import React, { Component } from 'react';
import { Link } from 'react-router-dom';
// import P5Wrapper from './components/P5Wrapper';

import Radium from 'radium';
import { slideInLeft, slideInRight } from 'react-animations';

import './Landing.css';

const subheaderStyles = {
    slideInLeft: {
        animation: 'x 1s',
        animationName: Radium.keyframes(slideInLeft, 'slideInLeft')
    },
    slideInRight: {
        animation: 'x 1s',
        animationName: Radium.keyframes(slideInRight, 'slideInRight')
    }
}

class Landing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false
        };

        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    render() {
        return (
            <div className="Landing noselect">
                <div className="banner-one">

                    {/*Insert p5 sketch */}
                    {/*<P5Wrapper/>*/}

                    <div className="call-to-action outer">
                        <div className="middle">
                            <div className="inner">
                                <h1>Get your stuff shipped, fast.</h1>
                                <h4 className="first-subheader">Sign up, add your stuff, start shipping.</h4>
                                <h4 className="second-subheader">Quickly deliver quality material to your fanbase.</h4>
                                <Link className="veles-router-link noselect" to='/onboard'>
                                    <button style={subheaderStyles.slideInRight}>Get started <i className="ion-android-send" /></button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default Landing;



// WEBPACK FOOTER //
// ./src/components/App/components/Main/components/Landing/Landing.js